import { FieldTypeIcon } from "../models/field-type-icon.enum";

export function fieldTypeIcon(fieldType: string = 'text'): FieldTypeIcon {
  return fieldType === 'text' ? FieldTypeIcon.text : FieldTypeIcon.dropdown;
}
